module.exports = __webpack_public_path__ + "img/zhutiweirao.a92ff72b.gif";